import type { SfxPool } from "./SfxPool";

export type SfxRecipe = (data: Float32Array, sampleRate: number) => void;

export const RECIPE_EAT: SfxRecipe = (data, sampleRate) => {
  for (let i = 0; i < data.length; i++) {
    const t = i / sampleRate;
    const env = Math.exp(-t * 14);
    const wob = Math.sin(2 * Math.PI * 18 * t) * 60;
    data[i] = Math.sin(2 * Math.PI * (520 + wob) * t) * env * 0.55;
  }
};

export const RECIPE_SPLASH: SfxRecipe = (data, sampleRate) => {
  for (let i = 0; i < data.length; i++) {
    const t = i / sampleRate;
    const noise = Math.random() * 2 - 1;
    const attack = Math.min(1, t * 40);
    const env = Math.exp(-t * 6) * attack;
    data[i] = noise * env * 0.4;
  }
};

export const RECIPE_ALERT: SfxRecipe = (data, sampleRate) => {
  const tonePeriod = 1 / 6;
  for (let i = 0; i < data.length; i++) {
    const t = i / sampleRate;
    const tone = Math.floor(t / tonePeriod);
    const tonePhase = t - tone * tonePeriod;
    const freq = tone % 2 === 0 ? 440 : 660;
    const env = Math.exp(-tonePhase * 24);
    data[i] = Math.sin(2 * Math.PI * freq * t) * env * 0.4;
  }
};

interface SfxDefinition {
  readonly duration: number;
  readonly recipe: SfxRecipe;
}

const SFX_DEFINITIONS: Readonly<Record<string, SfxDefinition>> = {
  eat: { duration: 0.18, recipe: RECIPE_EAT },
  splash: { duration: 0.32, recipe: RECIPE_SPLASH },
  alert: { duration: 0.5, recipe: RECIPE_ALERT },
};

export function generateSfxLibrary(ctx: BaseAudioContext, pool: SfxPool): void {
  const sampleRate = ctx.sampleRate;
  for (const [name, def] of Object.entries(SFX_DEFINITIONS)) {
    const length = Math.max(1, Math.round(def.duration * sampleRate));
    const buffer = ctx.createBuffer(1, length, sampleRate);
    const data = buffer.getChannelData(0);
    def.recipe(data, sampleRate);
    pool.register(name, buffer);
  }
}
